module.exports = __webpack_public_path__ + "img/02.c6e4ec5a.jpg";